import { register } from '../../../Javascript/Utils'

const CategoriesNavigation = el => {
  const collapseothers = el.dataset.collapseothers
  const componentPrefix = el.dataset.componentprefix
  const accordion = el.querySelectorAll(`.${componentPrefix}toggler`)

  accordion.forEach(item => item.addEventListener('click', e => {
    accordion.forEach(item => {
      if (e.currentTarget === item) {
        item.parentElement.classList.toggle('is--active')
      } else {
        if (collapseothers) {
          item.parentElement.classList.remove('is--active')
        }
      }
    })
  }))
}

register('CategoriesNavigation', CategoriesNavigation)
